import { useQuery } from '@tanstack/react-query'

import requests from 'service/api'

import SearchSelect from '../search-select'
import { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

export function SelectReferanceCode({ name }) {
  const { values, setFieldValue } = useFormikContext()
  const [selected, setSelected] = useState(null)
  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'referance'],
    queryFn: async () => {
      const { data } = await requests.referance.list()
      return data
    },
    placeholderData: []
  })

  const isWasgingLabel = data.filter((item) => item.labelCategory === 'YIKAMA TALİMATI')

  const options = isWasgingLabel.map(({ id, code }) => ({
    value: id,
    label: code
  }))

  useEffect(() => {
    if (values.washingLabel[0].referanceCode && isFetched) {
      const select = options.find(({ value }) => value === values.washingLabel[0].referanceCode)
      console.log('Referans Kodu Değişti:', {
        eskiDeger: selected?.value,
        yeniDeger: select?.value,
        referansKodu: select?.label
      })
      setSelected(select)
    }
    // eslint-disable-next-line
  }, [values.washingLabel[0].referanceCode, isFetched])

  const handleChange = (e) => {
    console.log('Referans Kodu Seçildi:', {
      eskiDeger: selected?.value,
      yeniDeger: e?.value,
      referansKodu: e?.label
    })
    setSelected(e)
    setFieldValue(name, e?.value)
  }

  return (
    <SearchSelect
      name={name}
      label="Referans Kodu"
      options={options}
      value={selected}
      onChange={handleChange}
    />
  )
}
